module.exports = __webpack_public_path__ + "img/cdr.76aea38.svg";